export const DATA_TESTID_BOOSTER_BUTTON = 'booster-button';

export const DATA_TESTID_BOOSTER_CONTAINER = 'booster_button_mf-pdp';
